// Shared active-page polling cadence introduced by IWA-18987. Combined with
// TanStack Query's default refetchOnWindowFocus/refetchOnMount and
// refetchIntervalInBackground: false, this satisfies "poll while active,
// pause when backgrounded, refresh on return" without a custom
// visibilitychange listener.
export const ACTIVE_PAGE_REFRESH_INTERVAL_MS = 30_000;

/**
 * The unread Work Orders badge must reflect a new or removed assignment within
 * five seconds, so it polls faster than the shared active-page cadence.
 */
export const UNREAD_WORK_ORDER_COUNT_REFRESH_INTERVAL_MS = 5_000;
